module.exports = __webpack_public_path__ + "assets/img/country.361caabe.svg";